export const SortIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 7.5L6 10L8.5 7.5M3.5 4.5L6 2L8.5 4.5"
      stroke="#A4A7AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
